import { TrackedValue } from '@atossa/core';

import { Api } from '../../Api';
import { User } from '@platform/cj-platform-navigation';
import { useCJForm } from '@cjdev-internal/visual-stack-x/CJForm';
import {
  Partner,
  PartnerName,
} from '@callback-cats/partnerships-ts/Partnership';
import React from 'react';

export const partnerField = 'partnerField';
export const keyField = 'keyField';
export const statusField = 'statusField';

export const disabledProdPartnerNames: PartnerName[] = [];

export interface PartnershipPageProps {
  api: Api;
  doc: Document;
  user: User;
  existingPartnerships: {
    tagId: string;
    partnerships?: TrackedValue<Partner>[];
  };
}

export interface DraftPartnerRow {
  /** Unique key for React rendering and row identification */
  readonly rowKey: string;
  /** Optional partner data for the row */
  readonly partnership?: Partner;
}

export interface PartnerRowProps {
  /** Unique identifier for the row group or component */
  readonly rowId: string;
  /** List of existing partners (immutable) */
  readonly existingRows: readonly Partner[];
  /** Draft rows being edited or added */
  draftPartnerRows: DraftPartnerRow[];
  /** Setter for updating draft partner rows */
  setPartnerRows: React.Dispatch<React.SetStateAction<DraftPartnerRow[]>>;
  /** Form configuration from useCJForm */
  readonly config: ReturnType<typeof useCJForm>;
}

// Define improved interface types
export interface PartnershipResult {
  success: boolean;
  message: string;
  partnership: Partner;
}

export interface PartnershipGroups {
  newPartnerships: Partner[];
  updatedPartnerships: Partner[];
}

export interface ProcessContext {
  api: Api;
  cid: string;
  tagId: string;
}
